import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Situacion.types';
import { ISituacion } from './Situacion.lib';
import moment from 'moment';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class Situacion extends ISituacion {

    public static async create( mes: number, ano: number, empresa: string ): Promise<Situacion> {
        let o = new Situacion();
        o.Mes = mes;
        o.Ano = ano;
        o.Empresa = Empresa.toTipo( empresa );

        if ( await o.find() ) {
            return o;
        }
        return null;
    }

    public static async actual( empresa: string ): Promise<Situacion>
    {
        let o = new Situacion();
        if ( moment().getDay() < 7 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Empresa = Empresa.toTipo( empresa );

        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/pantalla/situacion';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Empresa.Id}`;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Situacion>; Error?: boolean; }> {

        let a: Array<Situacion> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/pantalla/situacion` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Situacion( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }
}